// Windowed page list: 1 … 4 5 6 … 12 (with current centered).
function buildPages(page, pageCount, siblings = 1) {
  const total = siblings * 2 + 5; // first, last, current, 2 ellipses
  if (pageCount <= total) {
    return Array.from({ length: pageCount }, (_, i) => i + 1);
  }
  const left = Math.max(page - siblings, 1);
  const right = Math.min(page + siblings, pageCount);
  const showLeftDots = left > 2;
  const showRightDots = right < pageCount - 1;

  const pages = [1];
  if (showLeftDots) pages.push("…");
  else for (let i = 2; i < left; i++) pages.push(i);

  for (let i = left; i <= right; i++) {
    if (i !== 1 && i !== pageCount) pages.push(i);
  }

  if (showRightDots) pages.push("…");
  else for (let i = right + 1; i < pageCount; i++) pages.push(i);

  pages.push(pageCount);
  return pages;
}

export default function Pagination({ total, page, pageSize, onPageChange }) {
  const pageCount = Math.ceil(total / pageSize);
  if (pageCount <= 1) return null;

  const items = buildPages(page, pageCount);

  return (
    <nav className="pagination" aria-label="Pagination">
      <button
        className="page-btn"
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        aria-label="Previous page"
      >
        ‹
      </button>

      {items.map((p, i) =>
        p === "…" ? (
          <span key={`dots-${i}`} className="page-ellipsis" aria-hidden="true">
            …
          </span>
        ) : (
          <button
            key={p}
            className={`page-btn${p === page ? " active" : ""}`}
            onClick={() => onPageChange(p)}
            aria-current={p === page ? "page" : undefined}
          >
            {p}
          </button>
        )
      )}

      <button
        className="page-btn"
        disabled={page === pageCount}
        onClick={() => onPageChange(page + 1)}
        aria-label="Next page"
      >
        ›
      </button>
    </nav>
  );
}
